export const bacteriaMetaConfig = {

  'Akkermansia muciniphila': {
  title_label: 'Akkermansia muciniphila',
  formula: 'x',
  format: 'bar_color',
  customCondition: true,
  rangeMapping: [
      {
      condition: (x, formData) => x >= 35,
      score: 1,
      score_cal: 1,
      label: 'Deficient',
      color: '#003B5C'
      },
      {
      condition: (x, formData) => x < 35 && (x - formData['Universal bacteria']) > 19.93,
      score: 2,
      score_cal: 2,
      label: 'Slightly Deficient',
      color: '#00B0F0'
      },
      {
      condition: (x, formData) => x < 35 && (x - formData['Universal bacteria']) <= 19.93,
      score: 3,
      score_cal: 3,
      label: 'Normal',
      color: '#00B050'
      }
    ]
  },

  'Alistipes putredinis': {
    title_label: 'Alistipes putredinis',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
      },
          // {
          // condition: (x, formData) => x < 35 && (x - formData['Universal bacteria']) > 19.93,
          // score: 2,
          // score_cal: 2,
          // label: 'Slightly Deficient',
          // color: '#00B0F0'
          // },
      {
          condition: (x, formData) => x < 35,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },

  'Bacteroides fragilis': {
    title_label: 'Bacteroides fragilis',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35 || (x - formData['Universal bacteria']) >= 17.43,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => 15.4 < (x - formData['Universal bacteria']) && (x - formData['Universal bacteria']) < 17.43,
          // condition: (x, formData) => 15.4 < (x - formData['Universal bacteria']) <= 17.43,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => (x - formData['Universal bacteria']) <= 15.40,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },

  'Bacteroidetes phylum': {
    title_label: 'Bacteroidetes phylum',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x > 35 || (x - formData['Universal bacteria']) > 3.5,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
      },
      {
          condition: (x, formData) => (x - formData['Universal bacteria']) > 2.72 && (x - formData['Universal bacteria']) <= 3.5,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
      },
      {
          condition: (x, formData) => (x - formData['Universal bacteria']) <= 2.72,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },

  'Bacteroides genus': {
    title_label: 'Bacteroides genus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x > 35 || (x - formData['Universal bacteria']) > 3.5,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
      },
      {
          condition: (x, formData) => (x - formData['Universal bacteria']) > 2.72 && (x - formData['Universal bacteria']) <= 3.5,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
      },
      {
          condition: (x, formData) => (x - formData['Universal bacteria']) <= 2.72,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },

  'Blautia genus': {
    title_label: 'Blautia genus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x < 35,
          score: 5,
          score_cal: 5,
          label: 'Excessive',
          color: '#003B5C'
      },
      {
          condition: (x, formData) => x >= 35,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Clostridium cluster IV': {
    title_label: 'Clostridium cluster IV',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
        {
        condition: (x, formData) => x > 35 || (x - formData['Universal bacteria']) > 3.41,
        score: 1,
        score_cal: 1,
        label: 'Deficient',
        color: '#003B5C'
        },
        {
        condition: (x, formData) => (x - formData['Universal bacteria']) > 2.73 && (x - formData['Universal bacteria']) <= 3.41,
        score: 2,
        score_cal: 2,
        label: 'Slightly Deficient',
        color: '#00B0F0'
        },
        {
        condition: (x, formData) => (x - formData['Universal bacteria']) <= 2.73,
        score: 3,
        score_cal: 3,
        label: 'Normal',
        color: '#00B050'
        }
    ]
},
  'Enterococcus genus': {
    title_label: 'Enterococcus genus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
        {
        condition: (x, formData) => x > 35 || (x - formData['Universal bacteria']) > 18.58,
        score: 1,
        score_cal: 1,
        label: 'Deficient',
        color: '#003B5C'
        },
        {
        condition: (x, formData) => 14.99 < (x - formData['Universal bacteria']) && (x - formData['Universal bacteria']) <= 18.58,
        score: 2,
        score_cal: 2,
        label: 'Slightly Deficient',
        color: '#00B0F0'
        },
        {
        condition: (x, formData) => (x - formData['Universal bacteria']) <= 14.99,
        score: 3,
        score_cal: 3,
        label: 'Normal',
        color: '#00B050'
        }
    ]
},
  'Faecalibacterium prausnitzii': {
    title_label: 'Faecalibacterium prausnitzii',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x > 35 || (x - formData['Universal bacteria']) > 6.64,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => 5.06 < (x - formData['Universal bacteria']) && (x - formData['Universal bacteria']) <= 6.64,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => (x - formData['Universal bacteria']) <= 5.06,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
},

  'Roseburia hominis': {
    title_label: 'Roseburia hominis',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x > 35 || (x - formData['Universal bacteria']) > 19.07,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => 16.6 < (x - formData['Universal bacteria']) && (x - formData['Universal bacteria']) <= 19.07,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => (x - formData['Universal bacteria']) <= 16.6,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Ruminococcus genus': {
    title_label: 'Ruminococcus genus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
        {
        condition: (x, formData) => x > 35 || (x - formData['Universal bacteria']) > 8.22,
        score: 1,
        score_cal: 1,
        label: 'Deficient',
        color: '#003B5C'
        },
        {
        condition: (x, formData) => 5.93 < (x - formData['Universal bacteria']) && (x - formData['Universal bacteria']) <= 8.22,
        score: 2,
        score_cal: 2,
        label: 'Slightly Deficient',
        color: '#00B0F0'
        },
        {
        condition: (x, formData) => (x - formData['Universal bacteria']) <= 5.93,
        score: 3,
        score_cal: 3,
        label: 'Normal',
        color: '#00B050'
        }
    ]
  },
  'Bacillus genus': {
    title_label: 'Bacillus genus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x < 35 ,
          score: 5,
          score_cal: 5,
          label: 'Excessive',
          color: '#003B5C'
          },
          // {
          // condition: (x, formData) => x >35.01,
          // score: 2,
          // score_cal: 2,
          // label: 'Slightly Deficient',
          // color: '#00B0F0'
          // },
          {
          condition: (x, formData) => x >= 35 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Candida albicans': {
    title_label: 'Candida albicans',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x < 35 ,
          score: 5,
          score_cal: 5,
          label: 'Excessive',
          color: '#003B5C'
      },
      //     {
      //     condition: (x, formData) => x >= 34.5 && x < 35 ,
      //     score: 2,
      //     score_cal: 2,
      //     label: 'Slightly Deficient',
      //     color: '#00B0F0'
      //     },
          {
          condition: (x, formData) => x >= 35 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Clostridium difficile': {
    title_label: 'Clostridium difficile',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x < 35 ,
          score: 5,
          score_cal: 5,
          label: 'Excessive',
          color: '#003B5C'
      },
      //     {
      //     condition: (x, formData) => x >= 34.5 && x < 35 ,
      //     score: 2,
      //     score_cal: 2,
      //     label: 'Slightly Deficient',
      //     color: '#00B0F0'
      //     },
      {
          condition: (x, formData) => x >= 35 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Escherichia coli': {
    title_label: 'Escherichia coli',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x <= 35 && (x - formData['Universal bacteria']) <= 12.28,
          score: 5,
          score_cal: 5,
          label: 'Excessive',
          color: '#003B5C'
      },
      {
          condition: (x, formData) => 12.28 < (x - formData['Universal bacteria']) && (x - formData['Universal bacteria']) < 13.28,
          score: 4,
          score_cal: 4,
          label: 'Slightly Excessive',
          color: '#00B0F0'
      },
      {
          condition: (x, formData) => x >= 35 || (x - formData['Universal bacteria']) >= 13.28,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  // Staphylococcus aureus
  'Staphylococcus aureus': {
    title_label: 'Staphylococcus aureus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x < 35 && (x - formData['Universal bacteria']) <= 19 ,
          score: 5,
          score_cal: 5,
          label: 'Excessive',
          color: '#003B5C'
      },
      {
          condition: (x, formData) => x < 35,
          score: 4,
          score_cal: 4,
          label: 'Slightly Excessive',
          color: '#00B0F0'
      },
      {
          condition: (x, formData) => x >= 35 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Ruminococcus bromii': {
    title_label: 'Ruminococcus bromii',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
        condition: (x, formData) => x >= 35 || (x - formData['Universal bacteria']) > 8.22,
        score: 1,
        score_cal: 1,
        label: 'Deficient',
        color: '#003B5C'
      },
      {
        condition: (x, formData) => 5.93 < (x - formData['Universal bacteria']) && (x - formData['Universal bacteria'])<= 8.22,
        score: 2,
        score_cal: 2,
        label: 'Slightly Deficient',
        color: '#00B0F0'
      },
      {
        condition: (x, formData) => (x - formData['Universal bacteria']) <= 5.93,
        score: 3,
        score_cal: 3,
        label: 'Normal',
        color: '#00B050'
      }
    ]
},
  'Bifidobacterium bifidum': {
    title_label: 'Bifidobacterium bifidum',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Bifidobacterium lactis': {
    title_label: 'Bifidobacterium lactis',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Bifidobacterium longum': {
    title_label: 'Bifidobacterium longum',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35 || (x - formData['Universal bacteria']) >= 13.28,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => 12.28 < (x - formData['Universal bacteria']) && (x - formData['Universal bacteria']) < 13.28,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => (x - formData['Universal bacteria']) <= 12.28,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Bifidobacterium breve': {
    title_label: 'Bifidobacterium breve',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Lactobacillus acidophilus': {
    title_label: 'Lactobacillus acidophilus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35 ,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },

  'Lactobacillus gasseri': {
    title_label: 'Lactobacillus gasseri',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35 ,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Lactobacillus paracasei': {
    title_label: 'Lactobacillus paracasei',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
    {
        condition: (x, formData) => x >= 35 ,
        score: 1,
        score_cal: 1,
        label: 'Deficient',
        color: '#003B5C'
        },
        {
        condition: (x, formData) => x >= 34.5 && x < 35 ,
        score: 2,
        score_cal: 2,
        label: 'Slightly Deficient',
        color: '#00B0F0'
        },
        {
        condition: (x, formData) => x < 34.5 ,
        score: 3,
        score_cal: 3,
        label: 'Normal',
        color: '#00B050'
    }
    ]
  },
  'Lactobacillus rhamnosus': {
    title_label: 'Lactobacillus rhamnosus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
       {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35 ,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Streptococcus thermophilus': {
    title_label: 'Streptococcus thermophilus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
        {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35 ,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Lactobacillus helveticus': {
    title_label: 'Lactobacillus helveticus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35 ,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
  'Lactobacillus plantarum': {
  title_label: 'Lactobacillus plantarum',
  formula: 'x',
  format: 'bar_color',
  customCondition: true,
  rangeMapping: [
      {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35 ,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
  ]
  },

  'Lactobacillus reuteri': {
    title_label: 'Lactobacillus reuteri',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x >= 35 ,
          score: 1,
          score_cal: 1,
          label: 'Deficient',
          color: '#003B5C'
          },
          {
          condition: (x, formData) => x >= 34.5 && x < 35 ,
          score: 2,
          score_cal: 2,
          label: 'Slightly Deficient',
          color: '#00B0F0'
          },
          {
          condition: (x, formData) => x < 34.5 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },

  'Ruminococcus obeum': {
    title_label: 'Ruminococcus obeum',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      {
          condition: (x, formData) => x < 35,
          score: 5,
          score_cal: 5,
          label: 'Excessive',
          color: '#003B5C'
      },
      // {
      //     condition: (x, formData) => x < 35,
      //     score: 4,
      //     score_cal: 4,
      //     label: 'Slightly Excessive',
      //     color: '#00B0F0'
      // },
      {
          condition: (x, formData) => x >= 35,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },

  'Firmicutes phylum': {
    title_label: 'Firmicutes phylum',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      // {
      //     condition: (x, formData) => x < 35 && (x - formData['Universal bacteria']) <= 19 ,
      //     score: 5,
      //     score_cal: 5,
      //     label: 'Excessive',
      //     color: '#003B5C'
      // },
      {
          condition: (x, formData) => x < 11.5,
          score: 4,
          score_cal: 4,
          label: 'Slightly Excessive',
          color: '#00B0F0'
      },
      {
          condition: (x, formData) => x >= 11.5 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },

  'Firmicutes genus': {
    title_label: 'Firmicutes genus',
    formula: 'x',
    format: 'bar_color',
    customCondition: true,
    rangeMapping: [
      // {
      //     condition: (x, formData) => x < 35 && (x - formData['Universal bacteria']) <= 19 ,
      //     score: 5,
      //     score_cal: 5,
      //     label: 'Excessive',
      //     color: '#003B5C'
      // },
      {
          condition: (x, formData) => x < 11.5,
          score: 4,
          score_cal: 4,
          label: 'Slightly Excessive',
          color: '#00B0F0'
      },
      {
          condition: (x, formData) => x >= 11.5 ,
          score: 3,
          score_cal: 3,
          label: 'Normal',
          color: '#00B050'
      }
    ]
  },
}; 

// Export format-specific versions for backward compatibility
export const bacteriaMetaConfig_9P = bacteriaMetaConfig;
export const bacteriaMetaConfig_allergy = bacteriaMetaConfig;
export const bacteriaMetaConfig_toxin = bacteriaMetaConfig;
export const bacteriaMetaConfig_oms = bacteriaMetaConfig;
export const bacteriaMetaConfig_bwcallergy = bacteriaMetaConfig;
export const bacteriaMetaConfig_bwccore = bacteriaMetaConfig;
export const bacteriaMetaConfig_bwcdiamond = bacteriaMetaConfig;
export const bacteriaMetaConfig_allergy_kids = bacteriaMetaConfig;